import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-775d5e0e")

_pushScopeId("data-v-775d5e0e")
const _hoisted_1 = {
  id: "bulk-booking-create-internal-page",
  "data-testid": "bulk-booking-create-internal",
  style: {"display":"contents"}
}
const _hoisted_2 = {
  class: "pt-4 w-full max-w-4xl mx-auto flex flex-col gap-4 pb-10",
  "data-testid": "bulk-booking-create-internal-layout"
}
const _hoisted_3 = { class: "border border-gray-lp-1300 rounded-xl p-3 bg-white" }
const _hoisted_4 = { class: "mt-2" }
const _hoisted_5 = { class: "flex-shrink-0" }
const _hoisted_6 = { class: "border border-gray-lp-1300 rounded-md p-3 bg-white" }
const _hoisted_7 = /*#__PURE__*/_createVNode("hr", { class: "my-5 border-gray-lp-400" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_SectionFilterClientV2 = _resolveComponent("SectionFilterClientV2")!
  const _component_UploadFile = _resolveComponent("UploadFile")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_DownloadTemplate = _resolveComponent("DownloadTemplate")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_DetailLayout, {
        onBack: _ctx.goBack,
        title: _ctx.$t('bulkBooking.create.title'),
        "vertical-separator": false,
        fullPage: "",
        usePaddingVertical: false,
        customClass: "pr-0"
      }, {
        data: _withId(() => [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _createVNode(_component_DataWrapper, {
                "data-testid": "booking-bulk-create-internal-label-activity-name",
                label: _ctx.$t('bulkBooking.create.activityName'),
                class: "w-full mb-2"
              }, {
                default: _withId(() => [
                  _createVNode(_component_LpInput, {
                    type: "text",
                    errorIcon: false,
                    placeholder: _ctx.$t('bulkBooking.create.activityNamePlaceholder'),
                    maxLength: "56",
                    minLength: "3",
                    modelValue: _ctx.form.activityName,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.activityName = $event)),
                    onChange: _ctx.onChangeActivityName,
                    errorMessageMinLength: 
                  _ctx.$t('bulkBooking.create.validationChars')
                ,
                    showMaxLength: "",
                    "data-testid": "booking-bulk-create-internal-input-activity-name"
                  }, null, 8, ["placeholder", "modelValue", "onChange", "errorMessageMinLength"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_SectionFilterClientV2, {
                modelValue: _ctx.form,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form = $event))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_DataWrapper, {
                "data-testid": "booking-bulk-create-internal-label-upload",
                label: _ctx.$t('bulkBooking.create.uploadFileTitle'),
                class: "w-full mt-2"
              }, {
                default: _withId(() => [
                  _createVNode(_component_UploadFile, {
                    id: "upload-file",
                    type: "xlsx",
                    titleChange: _ctx.$t('bulkBooking.create.change'),
                    captionHtml: 
                  _ctx.$t('bulkBooking.create.uploadFileCaption', {
                    maxStt: _ctx.maximumStt,
                    maxMb: _ctx.maximumFileSize
                  })
                ,
                    isDraggable: false,
                    modelValue: _ctx.form.archiveFile,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.archiveFile = $event)),
                    errorMessage: _ctx.$t('bulkBooking.create.uploadFileErrorFormat'),
                    draggable: "xlsx",
                    customClass: "border border-solid",
                    maxRows: _ctx.maximumStt,
                    maxSize: _ctx.maximumFileSize
                  }, null, 8, ["titleChange", "captionHtml", "modelValue", "errorMessage", "maxRows", "maxSize"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode("div", _hoisted_4, [
                _createVNode(_component_LpButton, {
                  title: _ctx.$t('bulkBooking.create.upload'),
                  textColor: "white",
                  color: "red-lp-100",
                  fontWeight: "semibold",
                  id: "button_upload_bulk_booking",
                  disabled: _ctx.isBulkUploadValid,
                  onClick: _ctx._onAdd,
                  isWidthFull: ""
                }, null, 8, ["title", "disabled", "onClick"])
              ])
            ]),
            _createVNode("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, [
                _createVNode(_component_DownloadTemplate, {
                  "download-layout-column": "2-column",
                  title: _ctx.$t('bulkBooking.create.downloadTemplate'),
                  description: _ctx.$t('bulkBooking.create.downloadTemplateHint'),
                  typeDownload: "download-template",
                  dataComponent: _ctx.templateBookingData
                }, null, 8, ["title", "description", "dataComponent"]),
                _hoisted_7,
                _createVNode(_component_DownloadTemplate, {
                  downloadLayoutColumn: "2-column",
                  title: _ctx.$t('bulkBooking.create.checkFormatTitle'),
                  description: _ctx.$t('bulkBooking.create.checkFormatHint'),
                  typeDownload: "cek-format",
                  dataComponent: _ctx.templateComodityData
                }, null, 8, ["title", "description", "dataComponent"])
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onBack", "title"])
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      title: _ctx.$t('bulkBooking.create.uploadSuccessTitle'),
      onSubmit: _ctx.closePageUploadBulkBooking,
      message: _ctx.messageModalBookingOnProcess,
      image: "scan-cargoV2-badges/success",
      textSuccess: _ctx.$t('bulkBooking.create.btnUnderstand'),
      class: "px-8",
      customButton: "w-full",
      customParentButton: "w-full",
      customWrapperButton: "w-80"
    }, null, 8, ["title", "onSubmit", "message", "textSuccess"]), [
      [_vShow, _ctx.resultUpload]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      title: _ctx.errorTitle,
      onSubmit: _ctx.onSubmitFailedUploadBulkBooking,
      onClose: _ctx.onCloseUploadBulkBooking,
      message: _ctx.errorSubtitle,
      image: "ill_badge_failed",
      textSuccess: _ctx.btnModalFailed,
      textCancel: _ctx.btnModalCancel,
      class: "px-8",
      customButton: "w-full",
      customParentButton: "w-full",
      customWrapperButton: "w-80"
    }, null, 8, ["title", "onSubmit", "onClose", "message", "textSuccess", "textCancel"]), [
      [_vShow, _ctx.resultErrorUpload]
    ])
  ], 64))
})